import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import { FaChevronLeft } from "react-icons/fa6";
import {
  RowLeft, Button, ColumnCenter,
  Wrapper, RowBetween,
} from './Styles';
import './Styles.css';
import LanguageButton from '../LanguageButton';
import { getWindowHeight, getWindowWidth } from '../../../../lib/utils/utils';
import { aiChatWaiting } from '../../../../assets/base64Images/ai/aiChatWaiting';
import { aiChatLogo } from '../../../../assets/base64Images/ai/aiChatLogo';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../lib/axios/FoodifoxDataAPI';
import Q0 from './Q0';
import Q12 from './Q12';
import InterMediumText from '../../../../components/Text/InterMediumText';
import PingFangMediumText from '../../../../components/Text/PingFangMediumText';

const AiModal: FC<Props> = ({
  setShowModal,
  isEnglish,
  setIsEnglish,
  cabId,
  deviceCode,
  setTargetPage,
  setIsToSelectLockerPage,
  enterPhoneNumber,
}) => {
  // 检查当前柜子有没有订单
  const [checkCabHasOrder] = getFoodifoxDataLazy<{ status: boolean }>('/fox3PDAi/checkHasOrder');
  const [addAccessLog] = updateFoodifoxData('/fox3PDAiLog/saveAccessLog');

  const pageRef = useRef<HTMLDivElement>(null);
  const intervalRef = useRef<any>(null);
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState<number>(0);
  const [scrollEnd, setScrollEnd] = useState<number>();
  const [pageHeight, setPageHeight] = useState<number>(getWindowHeight());
  // loading
  const [checkCabHasOrderLoading, setCheckCabHasOrderLoading] = useState<boolean>(false);
  // 记录
  const [recordElement, setRecordElement] = useState<any[]>([]);

  useEffect(() => {
    // 页面加载完成后获取头部高度
    setHeaderHeight((headerRef.current as any)?.offsetHeight || 0);

    // 增加访问日志
    addAccessLog({
      param: {
        cabId,
        deviceCode,
      },
    });
  }, []);

  useEffect(() => {
    if (recordElement.length === 0) {
      // 检查当前柜子有没有订单
      setCheckCabHasOrderLoading(true);
      checkCabHasOrder({
        param: {
          useCabId: cabId,
        },
        onError() {
          // 隐藏loading
          setCheckCabHasOrderLoading(false);
          addElement(
            <Q12 />
          );
        },
        onCompleted({ status }) {
          setTimeout(() => {
            // 隐藏loading
            setCheckCabHasOrderLoading(false);
            if (status) {
              addElement(
                <Q0
                  addElement={addElement}
                  cabId={cabId}
                  deviceCode={deviceCode}
                  enterPhoneNumber={enterPhoneNumber}
                  setTargetPage={(targetPage) => {
                    setShowModal(false);
                    setTargetPage(targetPage);
                  }}
                  setIsToSelectLockerPage={setIsToSelectLockerPage}
                />,
              );
            }
            else {
              addElement(
                <Q12 />
              );
            }
          }, 2000);
        },
      });
    }
  }, [recordElement]);

  /**
   * 添加节点元素
   */
  const addElement = (element: any) => {
    if (JSON.stringify(element) === '[]') {
      setRecordElement([]);
    }
    else {
      recordElement.push(
        element,
      );
      setRecordElement([...recordElement]);
    }
  };

  /**
   * 滚动到底部
   */
  useEffect(() => {
    if (scrollEnd) {
      const current = pageRef.current;
      if (current) {
        // 获取页面的最后一个元素，这会帮助页面滑动到底部
        const lastElement: any = current.lastElementChild;
        // 使用scrollIntoView平滑滚动到该元素
        if (lastElement) {
          clearInterval(intervalRef.current);
          // 基础检查：确保scrollIntoView方法存在
          if ('scrollIntoView' in Element.prototype) {
            // 先滑动一次，然后在定时器里再做滑动，可以最大程度避免没有滚动到最底部
            lastElement.scrollIntoView({ behavior: 'smooth' });
            intervalRef.current = setInterval(() => {
              if (Math.abs(current.scrollTop + current.clientHeight - current.scrollHeight) < 1) {
                clearInterval(intervalRef.current);
              }
              else {
                lastElement.scrollIntoView({ behavior: 'smooth' });
              }
            }, 200);
          }
          else {
            intervalRef.current = setInterval(() => {
              if (current.scrollTop >= current.scrollHeight) {
                clearInterval(intervalRef.current);
              }
              else {
                current.scrollTop += 10;
              }
            }, 10);
          }
        }
      }
    }

    setPageHeight(getWindowHeight());

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [scrollEnd, recordElement]);

  /**
   * 滚动到底部
   */
  useEffect(() => {
    setScrollEnd(new Date().getTime());
  }, [recordElement]);

  return (
    <Wrapper
      onScroll={() => {
        setPageHeight(getWindowHeight());
      }}
      className={'div-scroll'}
      style={{ paddingBottom: 30, background: '#F7F7F7' }}
    >
      <RowBetween ref={headerRef} style={{ paddingTop: 25, paddingBottom: 25, background: '#FFFFFF', position: 'fixed', width: '100%', top: 0, zIndex: 1001 }}>
        {/* 返回箭头 */}
        <Button
          style={{ marginLeft: '15px' }}
          onClick={() => {
            setShowModal(false);
            setTargetPage('support');
          }}
        >
          <FaChevronLeft style={{ fontSize: '20px', marginTop: '7px', color: '#11202B' }} />
        </Button>

        <div style={{ position: 'absolute', top: 18, left: (getWindowWidth() - 42 / 2) / 2, width: 42, height: 42 }}>
          <img src={aiChatLogo} style={{ width: 42, height: 42 }} />
        </div>

        {/* 语言切换 */}
        <LanguageButton
          isEnglish={isEnglish}
          setIsEnglish={setIsEnglish}
          style={{ marginRight: 15 }}
        />
      </RowBetween>

      <div
        onScroll={() => {
          setPageHeight(getWindowHeight());
        }}
        ref={pageRef}
        className={'div-scroll'}
        style={{ width: '100%', height: pageHeight - headerHeight - 30, background: '#F7F7F7', overflowY: 'auto', overflowX: 'hidden', marginTop: headerHeight, paddingBottom: 10 }}
      >
        <ColumnCenter style={{ marginTop: 25 }}>
          {
            isEnglish ? (
              <InterMediumText fontSize={20} lineHeight={30}>
                Welcome to support chat
              </InterMediumText>
            ) : (
              <PingFangMediumText fontSize={20} lineHeight={30}>
                欢迎使用智能开柜服务
              </PingFangMediumText>
            )
          }
        </ColumnCenter>

        {
          // 检查当前柜子有没有订单Loading
          checkCabHasOrderLoading && (
            <RowLeft style={{ marginTop: 24 }}>
              <img src={aiChatWaiting} style={{ width: 74, height: 41 }} />
            </RowLeft>
          )
        }

        {
          recordElement.map((element, index) => {
            return (
              <div key={'record-' + index}>
                {element}
              </div>
            );
          })
        }
      </div>
    </Wrapper>
  );
};

export interface Props {
  setShowModal: (isShow: boolean) => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  cabId: number;
  deviceCode: string;
  setTargetPage: (targetPage: string) => void;
  setIsToSelectLockerPage?: (isToLockerPage: boolean) => void;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default AiModal;
